import { PollConfig } from '../../../../configFields';
import { MULTIPLE_ANSWERS_TYPE } from '../../../../configFields';

export const config: PollConfig & { name: 'POLL_MULTIPLE_FROM_PICTURE' } = {
  name: 'POLL_MULTIPLE_FROM_PICTURE' as const,
  traits: [MULTIPLE_ANSWERS_TYPE],
  title: 'Множественный выбор между картинками',
};
